import ServerValidationError from './ServerValidationError';

export default function isServerValidationError<TErrors, TResponse = object>(error: unknown): error is ServerValidationError<TErrors, TResponse> {
  return error instanceof ServerValidationError;
}
